//--------------------------------------------------------------------------
// General Laravel Axios Setup
//--------------------------------------------------------------------------

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.moment = require('moment');

if (document.head.querySelector('meta[name="user"]')) {
    window.user = JSON.parse(document.head.querySelector('meta[name="user"]').content);
}

var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

// Hide consoles in production
if (process.env.MIX_APP_DEBUG && process.env.MIX_APP_DEBUG == 'false') {
    console.log = function () {};
}

window.Vue = require('vue'); // vue object
window.Event = new Vue(); // event bus
window.SelectedProperty = null;

// Notify
import Snotify from 'vue-snotify/vue-snotify.min.js';
// import Snotify from 'vue-snotify';
import "vue-snotify/styles/material.css";
Vue.use(Snotify, {
    toast: {
        showProgressBar: false
    }
});

// catch all ajax errors and send to vue Error component
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 400) {
        Vue.prototype.$snotify.error(error.response.data.error, { timeout: 5000 });
    } else if (error.response.status === 422) {
        Vue.prototype.$snotify.error(error.response.data.errors, { timeout: 5000 });
    } else {
        Event.$emit("show-error", error);
    }
    return Promise.reject(error.response);
});

//--------------------------------------------------------------------------

// General Functions

// require('./auth.js')

//--------------------------------------------------------------------------
// Global Formatting Filters
//--------------------------------------------------------------------------

Vue.filter('toCurrency', function (value) {
    if (!value) value = 0;

    if (typeof value !== "number") {
        value = Number(value);
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.filter('toPercentage', function (value) {
    var result = 0;
    if (typeof value === "number" && !isNaN(value)) {
        result = Math.round(value * 100);
    } else if (parseFloat(value) == value) {
        result = parseFloat(value) * 100;
    }
    return result;
});

Vue.filter('addCommas', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.filter('phone', function (phone) {
    return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

Vue.filter('datePeriod', function (value) {
    if (moment(value).isValid()) return moment(value).format('MM-YYYY');
});

Vue.filter('dateFull', function (value) {
    if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
});

Vue.filter('dateTime', function (value) {
    if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY hh:mm A');
});

Vue.filter('convertBoolean', function (value) {
    return value === true || value === 1 ? 'Yes' : 'No';
});
Vue.filter('transactionType', function (is_credit) {
    return is_credit ? 'Credit' : 'Charge';
});

//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// Imports
//--------------------------------------------------------------------------
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.use(flatPickr);
flatpickr.setDefaults({ dateFormat: 'm/d/Y' });

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import VueChartkick from 'vue-chartkick';
import Highcharts from 'highcharts';
Vue.use(VueChartkick, { adapter: Highcharts });

// text input masks
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

// Vue Multiselect
import Multiselect from 'vue-multiselect';
// register globally
Vue.component('multiselect', Multiselect);

// numbers/currency input masks
import money from 'v-money';
Vue.use(money, {
    prefix: '$',
    suffix: '',
    thousands: ',',
    decimal: '.',
    precision: 2
});

// selector for Account period
import VueMonthlyPicker from 'vue-monthly-picker';
Vue.use(VueMonthlyPicker);
Vue.component('vue-monthly-picker', VueMonthlyPicker);

import VueUploadComponent from 'vue-upload-component';
Vue.component('file-upload', VueUploadComponent);

//Quill WYSIWYG
import { VueEditor } from 'vue2-editor';
Vue.component('vue-editor', VueEditor);

// Full Calendar
import FullCalendar from 'vue-full-calendar';
import 'fullcalendar/dist/fullcalendar.css';
Vue.use(FullCalendar);

//--------------------------------------------------------------------------


//--------------------------------------------------------------------------
// Vuex
//--------------------------------------------------------------------------
import Vuex from 'vuex';

Vue.use(Vuex);

var store = new Vuex.Store({
    state: {
        selectedProperty: 0,
        selectedPropertyName: '',
        currentResidents: [],
        pastResidents: [],
        isLoading: false
    },
    getters: {
        selectedProperty: function selectedProperty(state) {
            return state.selectedProperty;
        },
        selectedPropertyName: function selectedPropertyName(state) {
            return state.selectedPropertyName;
        },
        currentResidents: function currentResidents(state) {
            return state.currentResidents;
        },
        pastResidents: function pastResidents(state) {
            return state.pastResidents;
        }
    },
    mutations: {
        setSelectedProperty: function setSelectedProperty(state, selectedProperty) {
            state.selectedProperty = selectedProperty;
        },
        setCurrentResidents: function setCurrentResidents(state, currentResidents) {
            state.currentResidents = currentResidents;
        },
        setPastResidents: function setPastResidents(state, pastResidents) {
            state.pastResidents = pastResidents;
        },
        setIsLoading: function setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        }
    },
    actions: {
        getSelectedProperty: function getSelectedProperty(context) {},
        getCurrentResidents: function getCurrentResidents(context) {
            context.commit('setIsLoading', true);
            axios.get('/prototype/properties/residents').then(function (response) {
                context.commit('setCurrentResidents', response.data);
                context.commit('setIsLoading', false);
            });
        },
        getPastResidents: function getPastResidents(context) {
            context.commit('setIsLoading', true);
            axios.get('/prototype/properties/pastResidents').then(function (response) {
                context.commit('setPastResidents', response.data);
                context.commit('setIsLoading', false);
            });
        }
    }
});

store.watch(function (state) {
    return state.selectedProperty;
}, function (state) {
    window.axios.defaults.headers.common['x-selected-property'] = state;
    document.head.querySelector('meta[name="selected-property"]').content = state;
});
//--------------------------------------------------------------------------

import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

import { AgGridVue } from "ag-grid-vue";
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-material.css';
Vue.component('ag-grid-vue', AgGridVue);

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

var options = {
    name: '_blank',
    specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
    styles: ['https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css', 'https://unpkg.com/kidlat-css/css/kidlat.css']
};

Vue.use(VueHtmlToPaper, options);

//--------------------------------------------------------------------------
// Layout
//--------------------------------------------------------------------------

Vue.component('navigation', require('./components/layout/LeftNavigation.vue'));
Vue.component('header-bar', require('./components/layout/HeaderBar.vue'));
Vue.component('tabs', require('./components/layout/Tabs.vue'));
Vue.component('tab', require('./components/layout/SingleTab.vue'));
Vue.component('flyout', require('./components/layout/FlyOut.vue'));
Vue.component('data-table', require('./components/layout/DataTable.vue'));
Vue.component('profile-panel', require('./components/layout/ProfilePanel.vue'));
Vue.component('remove-modal', require('./components/layout/RemoveModal.vue'));
Vue.component('full-modal', require('./components/layout/FullModal.vue'));
Vue.component('small-modal', require('./components/layout/SmallModal.vue'));
Vue.component('step', require('./components/layout/SingleStep.vue'));
Vue.component('icon', require('./components/layout/Svg.vue'));
Vue.component('form-toggle', require('./components/layout/FormToggle.vue'));
Vue.component('error-bar', require('./components/layout/Error.vue'));
Vue.component('instant-search', require('./components/layout/InstantSearch.vue'));
Vue.component('lookup-table', require('./components/layout/LookupTable.vue'));
Vue.component('api-lookup-table', require('./components/layout/ApiLookupTable.vue'));
Vue.component('tooltip', require('./components/layout/Tooltip.vue'));
Vue.component('actions', require('./components/layout/Actions.vue'));
// ------ Multi-use ---------//

// These are not necessarily "generic", but cut across multiple sections. They are not "global" as that term has a meaning
Vue.component('new-ar-deposit', require('./components/multi-use/NewARDeposit.vue'));
// @TODO: combine with this one below
// Vue.component('ar-add-deposit', require('./components/accounting/accounts-receivable/deposits/AddDeposit.vue'));

//--------------------------//


//--------------------------------------------------------------------------
// Accounting
//--------------------------------------------------------------------------

// -- Dashboard
Vue.component('accounting-dashboard', require('./components/accounting/AccountingDashboard.vue'));

// -- General Ledger | Jouurnal Entries
Vue.component('journal-entry-list', require('./components/accounting/general-ledger/journal-entry/JournalEntryList.vue'));
Vue.component('add-journal-entry', require('./components/accounting/general-ledger/journal-entry/AddJournalEntry.vue'));
Vue.component('journal-entry-details', require('./components/accounting/general-ledger/journal-entry/JournalEntryDetails.vue'));
Vue.component('import-journal-entry', require('./components/accounting/general-ledger/journal-entry/ImportJournalEntry.vue'));

// -- General Ledger | GPR
Vue.component('gl-gpr-entry', require('./components/accounting/general-ledger/gpr/GprEntry.vue'));

// -- General Ledger | Recurring Journal Entries
Vue.component('recurring-journal-entry-list', require('./components/accounting/general-ledger/journal-entry/RecurringJournalEntryList.vue'));
Vue.component('recurring-journal-entry', require('./components/accounting/general-ledger/journal-entry/RecurringJournalEntry.vue'));

// -- General Ledger | Accounts
Vue.component('gl-account-list', require('./components/accounting/general-ledger/accounts/AccountList.vue'));
Vue.component('gl-account-details', require('./components/accounting/general-ledger/accounts/AccountDetails'));

// -- General Ledger | Reconcile
Vue.component('gl-reconcile-list', require('./components/accounting/general-ledger/reconcile/ReconcileList.vue'));
Vue.component('gl-add-reconcile', require('./components/accounting/general-ledger/reconcile/AddBankReconcile.vue'));
Vue.component('gl-completed-reconcile', require('./components/accounting/general-ledger/reconcile/CompletedReconcile.vue'));
Vue.component('gl-import-manual-transactions', require('./components/accounting/general-ledger/reconcile/ImportManualTransactions.vue'));
Vue.component('gl-add-adjustment', require('./components/accounting/general-ledger/reconcile/AddAdjustment.vue'));

// -- General Ledger | Budget
Vue.component('gl-budget-list', require('./components/accounting/general-ledger/budget/BudgetList.vue'));
Vue.component('gl-add-budget', require('./components/accounting/general-ledger/budget/AddBudget.vue'));
Vue.component('gl-import-budget', require('./components/accounting/general-ledger/budget/ImportBudget.vue'));
Vue.component('gl-edit-budget', require('./components/accounting/general-ledger/budget/EditBudget.vue'));

// -- General Ledger | Settings
Vue.component('gl-settings', require('./components/accounting/general-ledger/settings/GlSettings.vue'));
Vue.component('gl-close', require('./components/accounting/general-ledger/settings/GlClose.vue'));
Vue.component('chart-of-accounts', require('./components/accounting/general-ledger/settings/ChartOfAccounts.vue'));
Vue.component('single-account', require('./components/accounting/general-ledger/settings/chart-of-accounts/SingleAccount.vue'));
Vue.component('gl-setup', require('./components/accounting/general-ledger/settings/GlSetup.vue'));
Vue.component('gl-cache-rebuild', require('./components/accounting/general-ledger/settings/RebuildGLCache.vue'));

// -- General Ledger | Reports
Vue.component('gl-report-list', require('./components/accounting/general-ledger/reports/GlReportList.vue'));
Vue.component('gl-ledger-report', require('./components/accounting/general-ledger/reports/GlLedgerReport.vue'));
Vue.component('gl-ledger-report-detail', require('./components/accounting/general-ledger/reports/GlLedgerReport.vue'));
Vue.component('gl-income-report', require('./components/accounting/general-ledger/reports/GlIncomeReport.vue'));
Vue.component('gl-income-statement-report', require('./components/accounting/general-ledger/reports/GlIncomeStatementReport.vue'));
Vue.component('gl-reconcile-report', require('./components/accounting/general-ledger/reports/GlReconcileReport.vue'));
Vue.component('gl-balance-report', require('./components/accounting/general-ledger/reports/GlBalanceReport.vue'));
Vue.component('gl-budget-report', require('./components/accounting/general-ledger/reports/GlBudgetReport.vue'));
Vue.component('gl-trial-balance-report', require('./components/accounting/general-ledger/reports/GlTrialBalanceReport.vue'));
Vue.component('gl-tpp-transactions', require('./components/accounting/general-ledger/reports/GlTriplePlayPayTransactions.vue'));

// -- Accounts Payable | Dashboard
Vue.component('accounts-payable-dashboard', require('./components/accounting/accounts-payable/AccountsPayableDashboard.vue'));

// -- Accounts Payable | Invoices
Vue.component('ap-invoice-list', require('./components/accounting/accounts-payable/invoices/InvoiceList.vue'));
Vue.component('ap-recurring-invoice-list', require('./components/accounting/accounts-payable/invoices/RecurringInvoiceList.vue'));
Vue.component('ap-view-invoice', require('./components/accounting/accounts-payable/invoices/ViewInvoice.vue'));
Vue.component('ap-add-invoice', require('./components/accounting/accounts-payable/invoices/AddInvoice.vue'));
Vue.component('ap-edit-invoice', require('./components/accounting/accounts-payable/invoices/EditInvoice.vue'));
Vue.component('ap-import-invoice', require('./components/accounting/accounts-payable/invoices/ImportInvoice.vue'));

// -- Accounts Payable | Make Payments
Vue.component('ap-payment-list', require('./components/accounting/accounts-payable/payments/PaymentList.vue'));
Vue.component('ap-payment-details', require('./components/accounting/accounts-payable/payments/PaymentDetails.vue'));
Vue.component('ap-add-payment', require('./components/accounting/accounts-payable/payments/AddPayment.vue'));
Vue.component('ap-edit-payment', require('./components/accounting/accounts-payable/payments/EditPayment.vue'));
Vue.component('ap-export-payment', require('./components/accounting/accounts-payable/payments/ExportPayment.vue'));

// -- Accounts Payable | Checks
Vue.component('ap-check-list', require('./components/accounting/accounts-payable/checks/CheckList.vue'));
Vue.component('ap-view-check', require('./components/accounting/accounts-payable/checks/CheckDetails.vue'));
Vue.component('ap-add-check', require('./components/accounting/accounts-payable/checks/AddCheck.vue'));

// -- Accounts Payable | Reports
Vue.component('ap-report-list', require('./components/accounting/accounts-payable/reports/ApReportList.vue'));
Vue.component('ap-check-register-report', require('./components/accounting/accounts-payable/reports/ApCheckRegisterReport.vue'));
Vue.component('ap-aged-report', require('./components/accounting/accounts-payable/reports/ApAgedReport.vue'));
Vue.component('ap-detailed-aged-report', require('./components/accounting/accounts-payable/reports/ApDetailedAgedReport.vue'));

// -- Accounts Payable | Settings
Vue.component('ap-settings', require('./components/accounting/accounts-payable/settings/ApSettings.vue'));
Vue.component('ap-close', require('./components/accounting/accounts-payable/settings/ApClose.vue'));

// -- Accounts Receivable | Dashboard
Vue.component('accounts-receivable-dashboard', require('./components/accounting/accounts-receivable/AccountsReceivableDashboard.vue'));

// -- Accounts Receivable | Transactions
Vue.component('ar-transaction-list', require('./components/accounting/accounts-receivable/transactions/TransactionList.vue'));
Vue.component('ar-view-transaction', require('./components/accounting/accounts-receivable/transactions/TransactionDetails.vue'));
Vue.component('ar-recurring-transaction-list', require('./components/accounting/accounts-receivable/transactions/RecurringTransactionList.vue'));
Vue.component('gl-wizard-recurring', require('./components/accounting/accounts-receivable/transactions/ResidentLedgerWizardRecurring.vue'));
Vue.component('resident-recurring-transactions', require('./components/person/residents/ResidentRecurringTransactions.vue'));

// -- Accounts Receivable | Deposits
Vue.component('ar-deposit-list', require('./components/accounting/accounts-receivable/deposits/DepositList.vue'));
Vue.component('ar-add-deposit', require('./components/accounting/accounts-receivable/deposits/AddDeposit.vue'));
Vue.component('ar-deposit-details', require('./components/accounting/accounts-receivable/deposits/ARDepositDetails.vue'));

// Vue.component('ar-deposit-details', require('./components/accounting/accounts-receivable/deposits/ARDepositDetails.vue'));

// -- Accounts Receivable | Reports
Vue.component('ar-report-list', require('./components/accounting/accounts-receivable/reports/ArReportList.vue'));
Vue.component('ar-aging-report', require('./components/accounting/accounts-receivable/reports/ArAgingReport.vue'));
Vue.component('ar-aging-by-month-report', require('./components/accounting/accounts-receivable/reports/ArAgingByMonthReport.vue'));
Vue.component('ar-resident-ledger-report', require('./components/accounting/accounts-receivable/reports/ArResidentLedgerReport.vue'));
Vue.component('ar-deposit-register-report', require('./components/accounting/accounts-receivable/reports/ArDepositRegisterReport.vue'));
Vue.component('accrual-income-report', require('./components/accounting/accounts-receivable/reports/AccrualIncomeReport.vue'));

// -- Accounts Receivable | Settings
Vue.component('ar-settings', require('./components/accounting/accounts-receivable/settings/ArSettings.vue'));
Vue.component('ar-close', require('./components/accounting/accounts-receivable/settings/ArClose.vue'));
Vue.component('charge-code-settings', require('./components/settings/accounting/ChargeCodeSettings.vue'));

// -- Banking
Vue.component('add-bank-account', require('./components/accounting/banking/AddBankAccount.vue'));
Vue.component('manual-bank-account', require('./components/accounting/banking/EditManualAccount.vue'));
Vue.component('bank-account-list', require('./components/accounting/banking/BankAccountList.vue'));
Vue.component('bank-transactions', require('./components/accounting/banking/BankTransactions.vue'));

// -- Accounts Receivable | Billings
Vue.component('ar-billings-list', require('./components/accounting/accounts-receivable/billings/ArBillingsList.vue'));
Vue.component('ar-add-billing', require('./components/accounting/accounts-receivable/billings/ArAddBilling.vue'));
Vue.component('ar-view-billing', require('./components/accounting/accounts-receivable/billings/ArViewBilling.vue'));

//--------------------------------------------------------------------------


//--------------------------------------------------------------------------
// Properties / Building / Units
//--------------------------------------------------------------------------
Vue.component('property-dashboard', require('./components/property/PropertyDashboard.vue'));
Vue.component('property-list', require('./components/property/PropertyList.vue'));
Vue.component('new-property-wizard', require('./components/property/NewPropertyWizard.vue'));
Vue.component('property-summary', require('./components/property/PropertySummary.vue'));
Vue.component('property-website', require('./components/property/PropertyWebsite.vue'));
Vue.component('property-units', require('./components/property/dashboard/PropertyUnits.vue'));
Vue.component('move-out-alerts', require('./components/property/dashboard/MoveOutAlerts.vue'));
Vue.component('property-service-requests', require('./components/property/dashboard/PropertyServiceRequests.vue'));
Vue.component('import-property-wizard', require('./components/property/ImportPropertyWizard.vue'));

// -- Property | Buildings
Vue.component('building-list', require('./components/building/BuildingList.vue'));
Vue.component('building-details', require('./components/building/BuildingDetails.vue'));
Vue.component('add-building', require('./components/building/AddBuilding.vue'));
Vue.component('edit-building', require('./components/building/EditBuilding.vue'));

// -- Property | Units
Vue.component('unit-list', require('./components/unit/UnitList.vue'));
Vue.component('unit-add', require('./components/unit/AddUnit.vue'));
Vue.component('unit-edit', require('./components/unit/EditUnit.vue'));
Vue.component('unit-details', require('./components/unit/UnitDetails.vue'));
Vue.component('unit-summary', require('./components/unit/UnitSummary.vue'));
Vue.component('unit-wait-list', require('./components/unit/UnitAddWait.vue'));

// -- Property | Showings
Vue.component('add-showing', require('./components/unit/AddShowing.vue'));

// -- Property Settings
Vue.component('property-settings', require('./components/property/settings/PropertySettings.vue'));
Vue.component('property-settings-basic-information', require('./components/property/settings/PropertySettingsBasicInformation.vue'));
Vue.component('property-settings-charge-codes', require('./components/property/settings/PropertySettingsChargeCodes.vue'));
Vue.component('property-settings-lease-information', require('./components/property/settings/PropertySettingsLeaseInformation.vue'));
Vue.component('property-settings-unit-types', require('./components/property/settings/PropertySettingsUnitTypes.vue'));
Vue.component('property-settings-utilities', require('./components/property/settings/PropertySettingsUtilities.vue'));
Vue.component('property-settings-amenities', require('./components/property/settings/PropertySettingsAmenities.vue'));
Vue.component('property-settings-lease-details', require('./components/property/settings/PropertySettingsLeaseDetails.vue'));
Vue.component('property-settings-offboard-property', require('./components/property/settings/PropertySettingsOffboardProperty.vue'));
Vue.component('property-lease-settings-dashboard', require('./components/property/settings/PropertyLeaseSettingsDashboard.vue'));
Vue.component('property-actions', require('./components/property/settings/PropertyActions.vue'));
Vue.component('property-settings-portal', require('./components/property/settings/PropertySettingsPortal.vue'));
Vue.component('property-settings-nsf-payments', require('./components/property/settings/PropertySettingsNSFPayments.vue'));
Vue.component('property-settings-late-fees', require('./components/property/settings/PropertySettingsLateFees.vue'));
Vue.component('global-settings-late-fees', require('./components/settings/GlobalLateFeeSettings.vue'));
Vue.component('legacy-settings', require('./components/property/settings/LegacySettings.vue'));

// New Property Setting Slideouts
Vue.component('basic-settings', require('./components/property/settings/BasicSettings.vue'));
Vue.component('integration-settings', require('./components/property/settings/IntegrationSettings.vue'));
Vue.component('aquisition-disposition', require('./components/property/settings/AquisitionDispositionSettings.vue'));

// New Property Setting Slideouts
Vue.component('basic-settings', require('./components/property/settings/BasicSettings.vue'));
Vue.component('integration-settings', require('./components/property/settings/IntegrationSettings.vue'));
Vue.component('aquisition-disposition', require('./components/property/settings/AquisitionDispositionSettings.vue'));

// -- Property | Deposit Modal
Vue.component('property-deposit-modal', require('./components/property/PropertyDepositModal.vue'));

//--------------------------------------------------------------------------

/*----------  CMS Components  ----------*/

Vue.component('cms-btn', require('./components/cms/Btn.vue'));
Vue.component('cms-btn-group', require('./components/cms/BtnGroup.vue'));
Vue.component('cms-card', require('./components/cms/CMSCard.vue'));
Vue.component('cms-card-section', require('./components/cms/CMSCardSection.vue'));
Vue.component('cms-input', require('./components/cms/Input.vue'));
Vue.component('cms-text-area', require('./components/cms/TextArea.vue'));
Vue.component('cms-toggle', require('./components/cms/Toggle.vue'));
Vue.component('img-uploader', require('./components/cms/ImageUploader.vue'));
Vue.component('add-image', require('./components/cms/CMSAddImage.vue'));
Vue.component('cms-slideout', require('./components/cms/CMSSlideOut.vue'));
Vue.component('cms-jselect', require('./components/cms/CMSJSelect.vue'));
Vue.component('cms-timepicker', require('./components/cms/TimePicker.vue'));
Vue.component('cms-drag-drop', require('./components/cms/CMSDragAndDrop.vue'));
Vue.component('cms-drag-drop-single', require('./components/cms/CMSDragAndDropSingle.vue'));

Vue.component('cms-nav', require('./components/cms/CMSNavigation.vue'));

// CMS PAGES
Vue.component('cms-floorplans', require('./components/cms/pages/Floorplans.vue'));
Vue.component('cms-page-list', require('./components/cms/pages/PageList.vue'));
Vue.component('cms-page-home', require('./components/cms/pages/PageHome.vue'));
Vue.component('cms-page-neighborhood', require('./components/cms/pages/PageNeighborhood.vue'));
Vue.component('cms-page-amenities', require('./components/cms/pages/PageAmenities.vue'));
Vue.component('cms-page-floorplans', require('./components/cms/pages/PageFloorplans.vue'));
Vue.component('cms-contact', require('./components/cms/Contact.vue'));
Vue.component('cms-settings', require('./components/cms/CMSSettings.vue'));
Vue.component('prospect-edit', require('./components/cms/prospects/ProspectEdit.vue'));

Vue.component('cms-media', require('./components/cms/media/MediaMain.vue'));
Vue.component('cms-media-slideout', require('./components/cms/media/MediaSlideOut.vue'));
Vue.component('cms-media-preview', require('./components/cms/media/MediaSlideoutPreview.vue'));

//--------------------------------------------------------------------------
// Person
//--------------------------------------------------------------------------
Vue.component('person-dashboard', require('./components/person/PersonDashboard.vue'));
Vue.component('spinner', require('./components/person/shared/Spinner.vue'));

Vue.component('resident-list', require('./components/person/residents/ResidentList.vue'));
Vue.component('resident-list-dashboard', require('./components/person/residents/ResidentListDashboard.vue'));
Vue.component('resident-list-filter', require('./components/person/residents/ResidentListFilter.vue'));
Vue.component('resident-list-bldg', require('./components/person/ResidentListBuilding.vue'));
Vue.component('resident-notification', require('./components/person/residents/ResidentNotification.vue'));

Vue.component('movein-calculator', require('./components/person/MoveInCalculator.vue'));
Vue.component('pro-rated-rent-calculator', require('./components/person/ProRatedRentCalculator.vue'));

// -- Person | Guest Cards
Vue.component('guest-card-dashboard', require('./components/person/guest-cards/GuestCardDashboard.vue'));
Vue.component('guest-card-list', require('./components/person/guest-cards/GuestCardList.vue'));
Vue.component('archive-guest-card-list', require('./components/person/guest-cards/ArchiveGuestCardList.vue'));
Vue.component('add-guest-card-new', require('./components/person/guest-cards/AddGuestCardNEW.vue'));
Vue.component('edit-guest-card', require('./components/person/guest-cards/EditGuestCard.vue'));
Vue.component('view-guest-card', require('./components/person/guest-cards/GuestCardDetails.vue'));
Vue.component('archive-view-guest-card', require('./components/person/guest-cards/ArchiveGuestCardDetails.vue'));
Vue.component('guest-card-settings', require('./components/person/guest-cards/GuestCardSettings.vue'));

// -- Person | Applicants
Vue.component('applicant-dashboard', require('./components/person/applicants/ApplicantDashboard.vue'));
Vue.component('applicant-list', require('./components/person/applicants/ApplicantList.vue'));
Vue.component('view-applicant', require('./components/person/applicants/ApplicantDetails.vue'));
Vue.component('screening-application', require('./components/person/applicants/ApplicantScreeningApplication'));
Vue.component('resident-identity-verification', require('./components/person/applicants/ResidentIdentityVerification'));
Vue.component('applicant-ledger', require('./components/person/applicants/ApplicantLedger.vue'));
Vue.component('applicant-details-transactions', require('./components/person/applicants/ApplicantDetailsTransactions.vue'));
Vue.component('confirm-archive-applicant', require('./components/person/applicants/ConfirmArchiveApplicant.vue'));
Vue.component('applicant-refund-preview', require('./components/person/applicants/ApplicantRefundPreview.vue'));

// -- Person | Residents

// FS1: MoveOuts - New Resident Dashboard

// input component
Vue.component('r-input', require('./components/person/residents/new-resident-details/reusable/NewInputComponent.vue'));
Vue.component('r-button-toggle', require('./components/person/residents/new-resident-details/reusable/NewButtonToggle.vue'));
Vue.component('r-forwarding-address', require('./components/person/residents/new-resident-details/reusable/ForwardingAddress.vue'));

Vue.component('new-resident-dashboard', require('./components/person/residents/new-resident-details/ResidentDashboard.vue'));
Vue.component('new-resident-slide-out', require('./components/person/residents/new-resident-details/ResidentSlideOut.vue'));
Vue.component('new-resident-slide-out-cancel', require('./components/person/residents/new-resident-details/reusable/ResidentSlideOutCancelBox.vue'));
Vue.component('new-resident-ledger', require('./components/person/residents/new-resident-details/ResidentLedger.vue'));
Vue.component('new-resident-modify-payment-slideout', require('./components/person/residents/new-resident-details/ResidentModifyLedgerPaymentSlideout.vue'));
Vue.component('new-resident-overview', require('./components/person/residents/new-resident-details/ResidentOverview.vue'));
Vue.component('new-resident-tab', require('./components/person/residents/new-resident-details/ResidentTab.vue'));
Vue.component('new-resident-tabs', require('./components/person/residents/new-resident-details/ResidentTabs.vue'));
Vue.component('new-resident-actions-menu', require('./components/person/residents/new-resident-details/ResidentActionsMenu.vue'));

Vue.component('new-notice-to-vacate', require('./components/person/residents/new-resident-details/move-outs/NoticeToVacate.vue'));
Vue.component('new-notice-to-vacate-charges-summary', require('./components/person/residents/new-resident-details/move-outs/NoticeToVacateChargesSummary.vue'));
Vue.component('new-notice-to-vacate-summary', require('./components/person/residents/new-resident-details/move-outs/NoticeToVacateSummary.vue'));
Vue.component('new-move-out', require('./components/person/residents/new-resident-details/move-outs/MoveOut.vue'));
Vue.component('new-move-out-summary', require('./components/person/residents/new-resident-details/move-outs/MoveOutSummary.vue'));
Vue.component('new-nsf-summary', require('./components/person/residents/new-resident-details/nsf/NSFSummary.vue'));
Vue.component('new-lease-information', require('./components/person/residents/new-resident-details/LeaseInformation.vue'));
Vue.component('new-notice-history', require('./components/person/residents/new-resident-details/move-outs/NoticeHistory.vue'));

Vue.component('new-recurring-transactions-history', require('./components/person/residents/new-resident-details/ResidentRecurringTransactionsHistory.vue'));
Vue.component('new-recurring-transactions-list', require('./components/person/residents/new-resident-details/ResidentRecurringTransactions.vue'));

Vue.component('resident-portal-information', require('./components/person/residents/ResidentPortalInformation.vue'));
Vue.component('add-resident', require('./components/person/residents/AddResident.vue'));
Vue.component('move-in-type', require('./components/person/residents/MoveInType.vue'));
Vue.component('update-resident', require('./components/person/residents/EditResident.vue'));
Vue.component('resident-details-dashboard', require('./components/person/residents/ResidentDetailsDashboard.vue'));
Vue.component('resident-details-transactions', require('./components/person/residents/ResidentDetailsTransactions.vue'));
Vue.component('resident-modify-ledger-payment', require('./components/person/residents/ResidentModifyLedgerPayment.vue'));
Vue.component('resident-add-violation', require('./components/person/residents/ResidentAddViolation.vue'));
Vue.component('move-out-ledger', require('./components/person/past-residents/MoveOutLedger.vue'));
Vue.component('resident-confirm-portal-invite', require('./components/person/residents/ResidentConfirmPortalInvite.vue'));
Vue.component('resident-confirm-blacklist', require('./components/person/residents/ResidentConfirmBlacklist.vue'));
Vue.component('resident-transfer-unit', require('./components/person/residents/ResidentTransferUnit.vue'));
Vue.component('resident-renew-lease', require('./components/person/residents/ResidentRenewLease.vue'));
Vue.component('resident-add-payment', require('./components/person/residents/ResidentAddPayment.vue'));
// Vue.component('resident-send-notification', require('./components/person/residents/ResidentSendNotification.vue'));
Vue.component('resident-add-notes', require('./components/person/residents/ResidentAddNotes.vue'));
Vue.component('resident-details-history', require('./components/person/residents/ResidentDetailsHistory.vue'));
Vue.component('resident-details-settings', require('./components/person/residents/ResidentDetailsSettings.vue'));
// Vue.component('resident-details-lease', require('./components/person/residents/ResidentDetailsLease.vue'));
Vue.component('gl-wizard', require('./components/person/residents/ResidentLedgerWizard.vue'));
Vue.component('refund-preview', require('./components/person/residents/ResidentRefundPreview.vue'));
Vue.component('resident-rental-insurance', require('./components/person/residents/ResidentRentalInsurance.vue'));
Vue.component('change-insurance-plane', require('./components/person/residents/ResidentChangeInsurancePlan.vue'));
// -- Person | Past Residents
Vue.component('past-resident-list', require('./components/person/past-residents/PastResidentList.vue'));
Vue.component('past-resident-detail', require('./components/person/past-residents/PastResidentDetails.vue'));
Vue.component('past-resident-ar-deposit', require('./components/person/past-residents/PastResidentAddDeposit.vue'));

Vue.component('service-request-list', require('./components/property/ServiceRequestList.vue'));
Vue.component('service-request-detail', require('./components/property/ServiceRequestDetail.vue'));
Vue.component('service-request-new', require('./components/property/ServiceRequestAdd.vue'));
Vue.component('service-request-new-unit', require('./components/property/ServiceRequestAdd.vue'));
Vue.component('service-request-new-building', require('./components/property/ServiceRequestAdd.vue'));

// -- Person | Follow Ups
Vue.component('follow-up-list', require('./components/person/guest-cards/FollowUps.vue'));
Vue.component('add-follow-up', require('./components/person/guest-cards/AddFollowUp.vue'));

//-- Violation
Vue.component('violation-list', require('./components/violation/ViolationList.vue'));
Vue.component('add-violation', require('./components/violation/addViolation.vue'));
Vue.component('edit-violation', require('./components/violation/editViolation.vue'));

//-- Resident Notices
Vue.component('resident-notices', require('./components/person/residents/ResidentNotices.vue'));

//--------------------------------------------------------------------------
// Vendors
//--------------------------------------------------------------------------

Vue.component('vendor-list', require('./components/vendors/VendorList.vue'));
Vue.component('vendor-1099-list', require('./components/vendors/Vendor1099List.vue'));
Vue.component('archive-vendor-list', require('./components/vendors/ArchiveVendorList.vue'));
Vue.component('vendor-details', require('./components/vendors/VendorDetails.vue'));
Vue.component('vendor-add', require('./components/vendors/AddVendor.vue'));
Vue.component('vendor-edit', require('./components/vendors/EditVendor.vue'));

//--------------------------------------------------------------------------
// Notifications
//--------------------------------------------------------------------------

Vue.component('notification-templates', require('./components/notifications/NotificationTemplates.vue'));
Vue.component('single-template', require('./components/notifications/NotificationSingleTemplate.vue'));
Vue.component('new-notification', require('./components/notifications/NewNotification.vue'));
Vue.component('notification-history', require('./components/notifications/NotificationHistory.vue'));

//--------------------------------------------------------------------------
// Global Settings
//--------------------------------------------------------------------------

Vue.component('section-card', require('./components/settings/SectionCard.vue'));
Vue.component('roles-and-permissions-container', require('./components/settings/users/RolesAndPermissionsContainer'));
Vue.component('roles-with-permissions-container', require('./components/settings/users/RolesWithPermissionsContainer'));

/*----------- Accounting -----------*/

Vue.component('global-defaults', require('./components/settings/GlobalDefaultsList.vue'));
Vue.component('global-defaults-modal', require('./components/settings/GlobalDefaultsModal.vue'));

/*----------- Properties -----------*/
Vue.component('p-default_gl_codes', require('./components/settings/properties/DefaultGLCodes.vue'));
Vue.component('p-payment-types', require('./components/settings/properties/PaymentTypes.vue'));
Vue.component('p-amenities-list', require('./components/settings/properties/AmenitiesList.vue'));
Vue.component('p-moveout-reasons', require('./components/settings/properties/MoveOutReasons.vue'));
Vue.component('p-marketing-sources', require('./components/settings/properties/MarketingSources.vue'));
Vue.component('p-reversal-reasons', require('./components/settings/properties/ReversalReasons.vue'));
Vue.component('p-specials', require('./components/settings/properties/Specials.vue'));

/*----------- Vendors -----------*/
Vue.component('vendor-settings', require('./components/vendors/VendorSettings.vue'));

/*--------------Reports---------------*/
Vue.component('time-range-filter', require('./components/reporting/TimeRangeFilter.vue'));
Vue.component('date-period-filter', require('./components/reporting/DatePeriodFilter.vue'));

Vue.component('reporting-defaults', require('./components/reporting/GlobalReportsList.vue'));
Vue.component('global-reports', require('./components/reporting/GlobalReports.vue'));
Vue.component('delinquency-report', require('./components/reporting/DelinquencyReport.vue'));
Vue.component('price-planning-analysis', require('./components/reporting/PricePlanningAnalysisReport.vue'));
Vue.component('sales-commission-report', require('./components/reporting/SalesCommissionReport.vue'));
Vue.component('global-aging-report', require('./components/reporting/GlobalAgingReport.vue'));
Vue.component('global-insurance-report', require('./components/reporting/GlobalInsuranceReport.vue'));
Vue.component('global-defaults-reporting', require('./components/reporting/GlobalDefaultReport.vue'));

Vue.component('resident-reports', require('./components/person/residents/ResidentReports.vue'));
Vue.component('month-to-month', require('./components/person/residents/reports/MonthToMonth.vue'));
Vue.component('move-in-schedule', require('./components/person/residents/reports/MoveInSchedule.vue'));
Vue.component('move-out-schedule', require('./components/person/residents/reports/MoveOutSchedule.vue'));
Vue.component('resident-renewal-schedule', require('./components/person/residents/reports/ResidentRenewalSchedule.vue'));
Vue.component('move-ins-by-month', require('./components/person/residents/reports/MoveInsByMonth.vue'));
Vue.component('renter-insurance', require('./components/person/residents/reports/RenterInsurance.vue'));
Vue.component('renter-insurance-by-month', require('./components/person/residents/reports/RenterInsuranceByMonth.vue'));
Vue.component('sight-plan-report', require('./components/person/residents/reports/SlightPlanByMonth.vue'));
Vue.component('new-rent-roll', require('./components/person/residents/reports/NewRentRollReport.vue'));
Vue.component('rent-schedule', require('./components/person/residents/reports/RentSchedule.vue'));
Vue.component('rehab-report', require('./components/person/residents/reports/RehabReport.vue'));
Vue.component('renewals-report', require('./components/person/residents/reports/RenewalsReport.vue'));
Vue.component('pricing-sheet', require('./components/person/residents/reports/PricingSheet.vue'));
Vue.component('unit-amenity-list', require('./components/person/residents/reports/UnitAmenityList.vue'));
Vue.component('unit-availability', require('./components/person/residents/reports/UnitAvailabilityReport.vue'));
Vue.component('move-out-report', require('./components/person/residents/reports/MoveOutReport.vue'));
Vue.component('move-in-report', require('./components/person/residents/reports/MoveInReport.vue'));
Vue.component('resident-contact-info', require('./components/person/residents/reports/ResidentContactInfoReport.vue'));
Vue.component('lease-expiration-report', require('./components/person/residents/reports/LeaseExpirationReport.vue'));
Vue.component('occupancy-report', require('./components/person/residents/reports/OccupancyReport.vue'));
Vue.component('lead-to-lease-source', require('./components/person/residents/reports/LeadToLeaseSource.vue'));
Vue.component('lead-to-lease-user', require('./components/person/residents/reports/LeadToLeaseUser.vue'));
Vue.component('lease-to-lease-report', require('./components/person/residents/reports/LeaseToLeaseReport.vue'));
Vue.component('resident-pet-report', require('./components/person/residents/reports/ResidentPetReport.vue'));
Vue.component('service-request-report', require('./components/person/residents/reports/ServiceRequestReport.vue'));
Vue.component('insurance-report', require('./components/person/residents/reports/InsuranceReport.vue'));

Vue.component('traffic-detail', require('./components/person/guest-cards/reports/TrafficDetail.vue'));

Vue.component('online-payment-report', require('./components/person/residents/reports/OnlinePaymentReport.vue'));

/*----------- Users -----------*/
Vue.component('users-list', require('./components/users/UsersList.vue'));
Vue.component('user-add', require('./components/users/UserAdd.vue'));
Vue.component('user-add-api-user', require('./components/users/UserAddApiUser.vue'));
Vue.component('user-register', require('./components/users/UserRegister.vue'));
Vue.component('user-edit', require('./components/users/UserEdit.vue'));

/*-----------Person ------------*/
Vue.component('p-status', require('./components/settings/person/PersonStatus.vue'));
/*-----------Global Defaults - Ledger ------------*/
Vue.component('ledger-charge-import', require('./components/settings/ledgers/LedgerChargeImport.vue'));
Vue.component('rental-insurance-import', require('./components/settings/ledgers/RentalInsuranceImport.vue'));

Vue.component('resident-search', require('./components/search/ResidentSearch.vue'));

//--------------------------------------------------------------------------
// Mixins
//--------------------------------------------------------------------------
require('./validator.js');

//--------------------------------------------------------------------------
// Custom Plugin
//--------------------------------------------------------------------------
import PsValidation from "@primitivesocial/ps-validation";
Vue.use(PsValidation);

var app = new Vue({
    el: '#app',
    store: store
});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/app.js
// module id = null
// module chunks = 